import { lazy } from 'react';

const ElementaryCareersCareerModal = lazy(
  () => import('modules/ElementaryCareers/modals/CareerModal'),
);

const ElementaryCareersCheckInModal = lazy(
  () => import('modules/ElementaryCareers/modals/CheckInModal'),
);

export default {
  ELEMENTARY_CAREERS_CAREER_MODAL: ElementaryCareersCareerModal,
  ELEMENTARY_CAREERS_CHECK_IN_MODAL: ElementaryCareersCheckInModal,
};
